import { useState, useEffect } from 'react';

import { getBoxPlotConfig } from './UiPerformanceChartHelpers';
import { useFilterState } from '../../../stores/FilterStateStore';
import Chart from '../../charts/chart/Chart';
import { useDataService } from '../../../services/ApiDataService';

export default ({ search }) => {
    const dataService = useDataService();
    const [filterState] = useFilterState();
    const [chartData, setChartData] = useState(null);

    useEffect(() => {
        getBoxPlotConfig(dataService, filterState, search, setChartData);
    }, [dataService, filterState, search]);

    if (!chartData) return null;

    return <Chart options={chartData} onResize={() => {}} />;
};
